import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionEntryDetailsDto } from '@act/shared/data-transfer-objects';
import HtmlDisplayer from 'react-components/components/html-displayer';

export interface AccordionEntryProps {
  entry: AccordionEntryDetailsDto;
}

const AccordionEntry = ({ entry }: AccordionEntryProps) => {
  const { details, summary } = entry;

  return (
    <Accordion
      disableGutters
      sx={{
        padding: '0 16px',
        borderRadius: '0px !important',
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography variant="titleMedium">{summary}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ paddingLeft: 0 }}>
        <HtmlDisplayer innerHtml={details} />
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionEntry;
